import React from "react";
import { useLocation } from "react-router-dom";
import PageShell from "@/components/site/PageShell";
import PageHeader from "@/components/site/PageHeader";
import PensamentoContinuo from "@/components/PensamentoContinuo";
import { useTexts, fmtLongDate } from "@/components/home/PublicacoesPreview";
import { Container, Eyebrow, Body, Reveal } from "@/components/site/ui";
import { PUBLICACOES, TEMAS, IMG } from "@/content/site";

// Temas que atravessam a produção, sem numeração nem sequência obrigatória.
const TemasList = ({ texts }) => (
    <ul data-testid="publicacoes-temas" className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#1B3025] border border-[#1B3025]">
        {TEMAS.map((t) => {
            const works = (t.slugs || []).map((s) => texts.find((x) => x.slug === s)).filter(Boolean);
            return (
                <li key={t.k} className="bg-[#0E2018] p-7 md:p-8">
                    <h3 className="font-serif font-light text-[24px] text-[#F2EFE5]">{t.k}</h3>
                    <p className="mt-2 font-serif italic text-[16px] leading-[1.5] text-[#D7D1BF]">{t.q}</p>
                    {t.aprofundamento && <p className="mt-4 font-sans text-[10px] uppercase tracking-[0.24em] text-[#7E8978]">questões em aprofundamento</p>}
                    {works.map((w) => (
                        <a key={w.slug} href={`#${w.slug}`} className="mt-4 block font-sans font-light text-[12.5px] leading-[1.6] text-[#C7A659] hover:text-[#e2c886] transition-colors">
                            {fmtLongDate(w.created_at)} — {w.title} ↓
                        </a>
                    ))}
                </li>
            );
        })}
    </ul>
);

const PublicacoesPage = () => {
    const { data } = useTexts();
    const { hash } = useLocation();
    return (
        <PageShell path="/publicacoes" title="Publicações" sections={["header", "temas", "pensamento"]}>
            <PageHeader testId="publicacoes-page-header" eyebrow={PUBLICACOES.eyebrow} title={PUBLICACOES.title} lead={PUBLICACOES.lead} img={IMG.publicacoes} alt="Folhas manuscritas, cadernos e marcadores sobre uma mesa de estudo" />
            <section data-section-id="temas" className="py-12 md:py-20">
                <Container>
                    <Reveal className="max-w-3xl mb-12">
                        <Eyebrow>{PUBLICACOES.temasTitulo}</Eyebrow>
                        <Body>Os trabalhos se relacionam, mas nenhum foi concebido como etapa necessária do seguinte. As questões abaixo atravessam a produção em momentos diferentes.</Body>
                    </Reveal>
                    <Reveal delay={120}>{data && <TemasList texts={data} />}</Reveal>
                </Container>
            </section>
            <div data-section-id="pensamento">
                <PensamentoContinuo eyebrow="Cronologia" title="Textos publicados." openSlugInitial={hash ? hash.slice(1) : null} />
            </div>
        </PageShell>
    );
};

export default PublicacoesPage;
